export type PolicySlugItem = {
  _id?: string;
  slug: string;
  panel?: string;
  is_active?: boolean;
};

export type PolicyContent = {
  _id?: string;
  title?: string;
  slug?: string;
  panel?: string;
  content?: string;
};

export type PolicySlugsResponse = {
  success?: boolean;
  message?: string;
  data?: PolicySlugItem[];
};

export type PolicyContentResponse = {
  success?: boolean;
  message?: string;
  data?: PolicyContent;
};

export function formatPolicySlug(slug?: string) {
  if (!slug) return '';
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .replace(/\bAnd\b/g, '&');
}
